module.exports = __webpack_public_path__ + "img/connected-to-patient(drop to drop).eae1bfd6.svg";